// // socket.js (utils)
// import { io } from 'socket.io-client';
// import { SocketbaseURL } from '../BaseURL';

// const token = localStorage.getItem('accessToken');

// const socket = io(SocketbaseURL, {
//     extraHeaders: {
//         Authorization: `Bearer ${token}`
//     }
// });

// export default socket;

import { io } from 'socket.io-client';
import { SocketbaseURL } from '../BaseURL';

const token = localStorage.getItem('accessToken');

const socket = io(SocketbaseURL, {
    extraHeaders: {
        Authorization: `Bearer ${token}`
    }
});

// Add event listener to check connection
socket.on('connect', () => {
    console.log('Connected to socket server');
});

export default socket;